import { render, staticRenderFns } from "./TrackingProviders.vue?vue&type=template&id=6fa889c4&lang=pug"
import script from "./TrackingProviders.vue?vue&type=script&lang=js"
export * from "./TrackingProviders.vue?vue&type=script&lang=js"
import style0 from "./TrackingProviders.vue?vue&type=style&index=0&id=6fa889c4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports